var exports = {
  "v": "assigneeItem__luUQei",
  "z": "assigneeName__dvYCUT",
};

module.exports = exports;
